import React, { useEffect, useRef } from "react";
import SimulatorDashboard from "./SimulatorDashboard/SimulatorDashboard";
import SimulatorForms from "./SimulatorForm/SimulatorForms";
import "./../../../assets/styles/custom/components/dashboard/Simulator.scss";
import FormSimulator from "./FormSimulator/FormSimulator";
import InstructorSignature from "./InstructorSignature/InstructorSignature";
import { useIndexedDB } from 'react-indexed-db';
import moment from 'moment'
import firebase from "../../../Firebase/firebase"
import apolloclient from "../../../apollo_client";
import AWS from 'aws-sdk';
import { simformQueryList, updatesimform, submitstcform, simformpreview, SaveUrlSimForm, graphsimform } from './SimulatorQuery/SimulatorFormQuery'
const Simulator = () => {

  const { getAll: GetAllSfrid, add: AddSfrid, getByIndex, deleteRecord: deletesfrid } = useIndexedDB('sfrid');

  const childRef = useRef();
  useEffect(() => {
    let interval = setInterval(async () => {
      var connection = navigator.onLine;
      if (connection) {
        firebase.auth().onAuthStateChanged(async user => {
          if (user) {
            apolloclient.query({
              query: simformQueryList,
              variables: {
                id: user.uid
              }
            }).then(responses => {
              console.log("Inside Function", user.uid)
              var d = new Date();
              d.setDate(d.getDate() - 1);
              GetAllSfrid().then(simfromlocaldb => {
                simfromlocaldb.forEach(simsfrid => {
                  if (new Date(simsfrid.timestamp) < d) {
                    getByIndex('sfrid', simsfrid.sfrid).then(sfirdFromDB => {
                      if (sfirdFromDB) {
                        deletesfrid(sfirdFromDB.id).then(event => {
                          if (childRef.current) {
                            childRef.current.getLoadedData();
                          }
                        });
                      }
                    });
                  }
                })
              });
              console.log("Records List", responses.data?.aatmsv4_simformrecords);
              let simformlistdata = responses.data?.aatmsv4_simformrecords;
              if (simformlistdata && simformlistdata.length > 0) {
                GetAllSfrid().then(simfromlocaldb => {
                  //Adding Data in indexed DB
                  simformlistdata.forEach(simserverdata => {
                    if (simfromlocaldb.findIndex(x => x.sfrid === simserverdata.sfrid) < 0) {
                      console.log("Added", simserverdata.sfrid)
                      AddSfrid(simserverdata).then(() => {
                        console.log("Calling Child Method after Add")
                        if (childRef.current) {
                          childRef.current.getLoadedData();
                        }
                      })
                    }
                  });
                  //updating the record in Indexed DB
                  simfromlocaldb.forEach((simformdetails, index) => {
                    if (simformlistdata.findIndex(x => x.sfrid === simformdetails.sfrid) >= 0) {
                      let index = simformlistdata.findIndex(x => x.sfrid === simformdetails.sfrid);
                      if (new Date(simformdetails.timestamp) > new Date(simformlistdata[index].timestamp)) {
                        console.log("update DB records", simformdetails.sfrid, simformlistdata[index].timestamp, simformdetails.timestamp)
                        let traineesigngen = "";
                        if (simformdetails.traineesign) {
                          const s3 = new AWS.S3({

                            correctClockSkew: true,

                            endpoint: 'https://s3.eu-central-1.wasabisys.com', //Specify the correct endpoint based on where your bucket is

                            accessKeyId: 'NGEXI56XKDO46I0PF3UB',

                            secretAccessKey: 'b01KrlUiwgWFk0ZHGz8ch71W9gY9BpMI03qVCO9O',

                            region: 'eu-central-1'//Specify the correct region name based on where your bucket is

                            , logger: console

                          });
                          var buf = Buffer.from(simformdetails.traineesign.replace(/^data:image\/\w+;base64,/, ""), 'base64')
                          const uploadRequest = new AWS.S3.ManagedUpload({

                            params: {
                              Bucket: 'amiagi/straineesign', Key: simformdetails.sfrid, ContentEncoding: 'base64',
                              ContentType: 'image/png', Body: buf
                            },

                            service: s3

                          });
                          uploadRequest.on('httpUploadProgress', function (event) {

                            const progressPercentage = Math.floor(event.loaded * 100 / event.total);

                            console.log('Upload progress ' + progressPercentage);

                          });
                          traineesigngen = 'https://s3.eu-central-1.wasabisys.com/amiagi/straineesign/' + simformdetails.sfrid
                          console.log('Configed and sending', traineesigngen);

                          uploadRequest.send(function (err) {

                            if (err) {

                              console.log('UPLOAD ERROR: ' + JSON.stringify(err, null, 2));

                            } else {

                              console.log('Good upload');

                            }
                          });
                        }

                        console.log(traineesigngen)
                        apolloclient.mutate({
                          mutation: updatesimform,
                          variables: {
                            sfrid: simformdetails.sfrid,
                            published: simformdetails.published,
                            preview: simformdetails.preview,
                            knowledge: simformdetails.knowledge,
                            skil: simformdetails.skil,
                            attitude: simformdetails.attitude,
                            app: simformdetails.app,
                            tkn: simformdetails.tkn,
                            fpa: simformdetails.fpa,
                            fpm: simformdetails.fpm,
                            com: simformdetails.com,
                            ltw: simformdetails.ltw,
                            pdm: simformdetails.pdm,
                            saw: simformdetails.saw,
                            wlm: simformdetails.wlm,
                            cal: simformdetails.cal,
                            remarkstext: simformdetails.remarkstext,
                            resulttext: simformdetails.resulttext,
                            traineesign: traineesigngen,
                            trainersign: simformdetails.trainersign,
                            timestamp: new Date().toISOString(),
                            validtill: simformdetails.resulttext === "Un-Satisfactory" ? moment(new Date(), "yyyy-MM-DD").add(-1, 'days').format("YYYY-MM-DD")
                              : simformdetails.validtill,
                          }
                        }).then(simformdata => {
                          let stclength = simformdetails.stcrecords.length;
                          let i = 0;
                          if (stclength) {
                            simformdetails.stcrecords.forEach(stcrecords => {
                              apolloclient.mutate({
                                mutation: submitstcform,
                                variables: {
                                  ata: 1,
                                  sits: stcrecords.sits,
                                  score: stcrecords.score,
                                  patch: stcrecords.patch,
                                  published: stcrecords.published,
                                  sfrid: stcrecords.sfrid,
                                  stcrid: stcrecords.stcrid
                                }
                              }).then(data => {
                                i = i + 1;
                                if (stclength === i) {
                                  if (simformdetails.published) {
                                    previewaftersave(simformdetails);
                                    getByIndex('sfrid', simformdetails.sfrid).then(sfirdFromDB => {
                                      if (sfirdFromDB) {
                                        deletesfrid(sfirdFromDB.id).then(event => {
                                          console.log("published record deleted successfully");
                                          if (childRef.current) {
                                            childRef.current.getLoadedData();
                                          }
                                        }).catch(err => {
                                          console.log(err);
                                        })
                                      }
                                    });
                                  } else {
                                    console.log("Updated not published")
                                  }
                                }
                              }).catch(error => {
                                console.log(error)
                              })
                            })
                          } else {
                            if (simformdetails.published) {
                              previewaftersave(simformdetails);
                              getByIndex('sfrid', simformdetails.sfrid).then(sfirdFromDB => {
                                if (sfirdFromDB) {
                                  deletesfrid(sfirdFromDB.id).then(event => {
                                    console.log("deleted successfully");
                                    if (childRef.current) {
                                      childRef.current.getLoadedData();
                                    }
                                  }).catch(err => {
                                    console.log(err);
                                  })
                                }
                              });
                            }
                          }
                        }).catch(error => {
                          console.log(error)
                        })
                      } else {
                        console.log("Data is Up To Date" + simformdetails.sfrid)
                      }
                    }
                  });
                });
              }
            })
          }
        });
      }
    }, 20000);
    return () => {
      console.log("cleaned")
      clearInterval(interval)
    }
  }, [])
  function previewaftersave(simformdetails) {
    apolloclient.query({
      query: simformpreview,
      variables: {
        sfrid: simformdetails.sfrid,
        preview: false,
        published: true
      }
    }).then(querypreview => {
      let simformpreviewdata = querypreview.data.aatmsv4_simformrecords[0];
      let generateSimForm = firebase.functions().httpsCallable('sim-training-form');
      let requestobj = {
        aatmsv4_simforms: [simformpreviewdata],
        stcrecords: simformpreviewdata.stcrecords
      }
      console.log("sim-trianing-form", requestobj);
      let isgraph = false;
      simformdetails.stcrecords.forEach(stcrecords => {
        if (stcrecords.patch !== '') {
          isgraph = true
        }
      });
      if (isgraph) {
        let currentYear = new Date().getFullYear();
        let start = currentYear + "-01-01";
        let end = currentYear + "-12-31"
        apolloclient.query({
          query: graphsimform,
          variables: {
            crewid: simformdetails.traineeid,
            start: start,
            end: end
          }
        }).then(graphdata => {
          const generateGraphSimForm = firebase.functions().httpsCallable('trainingPerformanceReport');
          let graphobj = {
            aatmsv4_crews: [graphdata.data.aatmsv4_crews[0]]
          }
          console.log('gaphql data', JSON.stringify(graphobj));
          generateGraphSimForm(graphobj)
            .then((simgraph) => {
              console.log("graph generated")
              console.log(simgraph)
            }).catch(error => {
              console.log(error)
            })
        });
      }
      console.log(JSON.stringify(requestobj));
      generateSimForm(requestobj)
        .then((simformdata) => {
          console.log(simformdata);

          apolloclient.mutate({
            mutation: SaveUrlSimForm,
            variables: {
              sfrid: simformdetails.sfrid,
              stcrecord: simformdata.data.url
            }
          }).then(data => {
            console.log("Graph Completed")

          })
        })
        .catch(err => {
          console.log(`Error Occured!! ${err}`);
        });
    })
  }
  const simulatorComponents = (props) => {
    const component = window.location.pathname.split("/")[3];
    if (!component) {
      return <SimulatorDashboard props={props} />;
    } else if (component === "simulator-forms") {
      return <SimulatorForms ref={childRef} props={props} />;
    } else if (component === "forms") {
      return <FormSimulator />
    } else if (component === "instructorsignature") {
      return <InstructorSignature />
    }
  };
  return simulatorComponents();
};

export default Simulator;
